import { ChevronDown } from 'lucide-react';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

type Option<T> = { value: T; label: string };

type Props<T> = {
  options: Option<T>[];
  onChange: (value: Option<T>) => void;
  value?: Option<T>;
};

const Ordering = <T extends number | string>({
  onChange,
  options,
  value,
}: Props<T>) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center gap-1 text-sm text-neutral-1000 md:text-body">
        Sort by: <span className="!font-semibold">{value?.label}</span>{' '}
        <ChevronDown className="h-4 w-4 shrink-0 text-neutral-1000" />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-[196px] rounded-lg border-0 bg-neutral-100 text-neutral-1000">
        {options.map((order) => (
          <DropdownMenuItem
            onClick={() => onChange(order)}
            key={order.value.toString()}
            className="!font-normal"
          >
            {order.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default Ordering;
